export default function () {
  const widgetName = 'ticketButton';
  const widgetOpts = ticketButtonOpts;

  const wrapContainerClass = 'ticket-container';
  const $widget = $(`#${widgetName}`);

  $widget.wrap(`<div class="${wrapContainerClass}"><div class="inner-container"></div></div>`);

  return saffire.widgets.cardWidget($($widget), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    scriptPath: widgetOpts.scriptPath,
    link: ['all'],
    showDescription: false,
    hasImages: false,
    lazyLoadImages: false,
    imageIsBackground: false,
    textOverImage: false,
    moreButton: false,
    maxItemsVisible: 1,
    itemsPerPanel: 1,
    buyNowButton: false,
    cardWidgetLoaded: function (data) {
      const widgetData = data.items;

      if (widgetData.length <= 0) {
        $('body').addClass(`${widgetName}-no-data`);
        $(`.${wrapContainerClass}`).remove();
      } else {
        createCustomCards(widgetData, wrapContainerClass);
        $(`#${widgetName}`).css('display', 'inline-flex');
      }
    },
  });

  function createCustomCards(widgetData, wrapContainerClass) {
    $widget.find('.card-widget-item').each(function (x) {
      const { Title, URL } = widgetData[x];

      const $cardItem = $(this);
      $cardItem.find('.card-content').remove();
      $cardItem.append(`
          <a  ${URL ? `<a href="${URL}"` : ''} class="card-content">
            <div class="widget-title-wrapper">
              <span class="widget-title">
                ${Title}</span>
              </div>
             
            </div>
          </a>`);

      $cardItem.removeAttr('target');

      if (!URL) {
        $(`.${wrapContainerClass}`).remove();
      } else {
        $cardItem.addClass('only-url');
      }
    });
  }
}
